// MAN01 - Marks and Numbers Qualifier, used by the 856's MAN segment to
// identify a Pack or Tare by its shipping label/container marking.

import type {CodeListEntry} from './types';

export const MARKS_AND_NUMBERS_QUALIFIER_CODES: CodeListEntry[] = [
  {code: 'GM', label: 'SSCC-18 and Application Identifier'},
  {code: 'AA', label: 'SSCC-18'},
  {code: 'UC', label: 'U.P.C. Shipping Container Code'},
  {code: 'CP', label: 'Carrier-Assigned Package ID Number'},
  {code: 'CA', label: 'Shipper-Assigned Case Number'},
  {code: 'W', label: 'Pallet Number'},
  {code: 'ZZ', label: 'Mutually Defined'},
];
